import React from 'react';
import CoolenMoveUrl from "@/pcomponents/common/content/coolen/study/func/move_url";
import strFunc from '@/lib/lyg/string';

function DetailRow(props: any) {
  let myProps = {
    use_info: null,
    text_book_info: null,
    is_preview_only_first:false,
    open_word_group_result_popup: (inData: any) => { },
    ...props
  };
  let use_info = myProps.use_info;
  let text_book_info = myProps.text_book_info;

  const get_detail_tags = (inData: any) => {
    let opt_obj = {
      section_info: null,
      ...inData
    };
    let section_info = opt_obj.section_info;
    let detail_arr: any = [];
    if (text_book_info != null && text_book_info.study_arr) {
      for (let i = 0; i < text_book_info.study_arr.length; i++) {
        let study_info = text_book_info.study_arr[i];
        if (study_info.a_section_seq == section_info.a_seq) {
          detail_arr.push(study_info);
        }
      }
    }

    let detail_tags = detail_arr.map((detail: any, idx: number) => {

      let use_det:any = null;
      if (use_info && use_info.use_det_arr) {
        for (let u_i = 0; u_i < use_info.use_det_arr.length; u_i++) {
          let u_det = use_info.use_det_arr[u_i];
          if (u_det.a_book_list_seq == detail.a_seq) {
            use_det = u_det;
            break;
          }
        }
      }
      let use_score_str = "";
      if (use_det != null) {
        use_score_str = use_det.a_success_record + "%";
        use_score_str += " (" + use_det.a_success_amount + "/" + use_det.a_amount + ")";
      }

      let pre_view_btn: any = "";
      let pre_title_str=text_book_info.a_title+" - "+detail.a_title;
      if (detail.a_par_id == "contents_book" && !strFunc.is_empty(detail.a_par_seq)) {
        pre_view_btn = (
          <button className="btn-s btn-gray ml-1"
            onClick={() => {
              CoolenMoveUrl.go_to_study_url({
                coolen_study_par_id: "mtextbook_list",
                detail_info: detail,
                study_is_save: "",
                is_new_window: "1",
                back_sort: "popup",
                title: pre_title_str,
              });
            }}>미리보기</button>
        );
      } else if (detail.a_par_id == "abc_study" && !strFunc.is_empty(detail.a_par_seq)) {
        pre_view_btn = (
          <button className="btn-s btn-gray ml-1"
            onClick={() => {
              let study_list_pri_val = detail["a_book_seq"] + "," + detail["a_seq"];
              CoolenMoveUrl.go_to_url({
                coolen_study_par_id: "mtextbook_list",
                coolen_study_par_seq: study_list_pri_val,
                coolen_study_sort: "abc",
                study_is_save: "",
                is_new_window: "1",
                back_sort: "popup",
                title: pre_title_str,
              });
            }}>미리보기</button>
        );
      } else {
        if (detail.cg_word_arr && detail.cg_word_arr.length > 0) {
          let word_cnt_str = "(" + detail.cg_word_arr.length + ")";
          pre_view_btn = (
            <span>
              {word_cnt_str}
              <button className="btn-s btn-gray ml-1"
                onClick={() => {
                  CoolenMoveUrl.go_to_url({
                    coolen_study_par_id: "mtextbook_list",
                    coolen_study_par_seq: detail["a_book_seq"] + "," + detail["a_seq"],
                    coolen_study_sort: "word2",
                    study_is_save: "",
                    is_new_window: "1",
                    back_sort: "popup",
                    title: pre_title_str,
                  });
                }}>미리보기</button>
            </span>
          );
        }
      }

      if(myProps.is_preview_only_first){
        if(idx!=0){
          pre_view_btn="";
        }
      }

      return (
        <tr key={idx}>
          <td className='text-center'>{idx + 1}</td>
          <td>{detail.a_title}</td>
          <td className='text-center'>
            {pre_view_btn}
          </td>
          <td className='text-center'>
            {use_score_str}
          </td>
          <td className='text-center'>
            {use_det != null &&
              <button className='btn btn-dark'
                onClick={() => {
                  if (use_det != null) {
                    myProps.open_word_group_result_popup({
                      g_par_id: "mtextbook_list",
                      g_par_seq: detail["a_book_seq"] + "," + detail["a_seq"],
                      stu_seq: use_det.a_stu_seq,
                    });
                  }
                }}
              >학습결과</button>
            }
          </td>
        </tr>
      );
    });

    return detail_tags;
  };

  const get_section_tags = () => {
    let section_arr: any = [];
    if (text_book_info != null && text_book_info.section_arr) {
      section_arr = text_book_info.section_arr;
    }

    let section_tags = section_arr.map((section: any, idx: number) => {
      return (
        <React.Fragment key={idx}>
          <tr>
            <td colSpan={99}>
              {section.a_title}
            </td>
          </tr>
          {get_detail_tags({ section_info: section })}
        </React.Fragment>
      );
    });

    return section_tags;
  };

  return (
    <div>
      <div>
        <table style={{ width: "auto" }}>
          <colgroup>
            <col width={"20px"}></col>
            <col width={"400px"}></col>
            <col width={"80px"}></col>
            <col width={"100px"}></col>
            <col width={"100px"}></col>
          </colgroup>
          <tbody>
            {get_section_tags()}
          </tbody>
        </table>
      </div>

    </div>
  );
};
export default DetailRow;